import { Box, Typography } from '@material-ui/core';

import { ControlledSelect } from '../../../../components/controlled-inputs';
import { selectOptions } from '../config/constants';
import { getNameForField } from '../helpers/getNameForField';
import { RuleSchema } from '../types';

export const NoPaidBreaksForNonFullShifts = ({ uuid, ...rest }: RuleSchema) => {
  return (
    <Box marginTop={1} marginBottom={1} display="flex" gridGap={8} alignItems="center" flexWrap="wrap">
      <Typography variant="caption" color="textSecondary">
        If a team member does not complete at least
      </Typography>
      <Box width="94px">
        <ControlledSelect name={getNameForField(uuid, 'hours_amount_needed')} items={selectOptions.hours} />
      </Box>
      <Typography variant="caption" color="textSecondary">
        hours of a daily
      </Typography>
      <Typography variant="caption" color="textSecondary">
        shift, remove any paid breaks from their daily Paid Hours.
      </Typography>
    </Box>
  );
};
